export default {
  name: 'Liquidity bucket |||| Liquidity buckets',
  alias: 'Liquidity bucket name',
  accountNumber: 'Account number',
  bucketIdentifier: 'Bucket identifier',
  currency: 'Currency',
  description: 'Description',
  status: 'Status',
  // accountSummary: 'Account summary',
  balances: 'Balances',
  balance: 'Balance',
  amount: 'Amount',
  liquidityBucketDetails: 'Liquidity bucket details',
  total: 'Total',
  tabs: {
    details: 'Details',
    bankDaySummary: 'Bank day summary',
    // transactions: 'Transactions',
    transfers: 'Transfers',
  },
  addBank: 'Add liquidity bucket',
  editBank: 'Edit liquidity bucket',
  transactionsHistory: {
    bankingDay: 'Banking day',
    totalOperations: 'Total operations number',
    postedAmount: 'Posted amount',
    cpLiquidityBucket: 'CP liquidity bucket',
    liquidityBucket: 'Liquidity bucket',
    account: 'Account',
    cpAccount: 'CP account',
    from: 'Sender',
    to: 'Recipient',
    dateAndTime: 'Date & Time',
    trnId: 'Transaction ID',
    linkToHeadTransaction: 'Link to Head Transaction',
    originalTransactionId: 'Original transaction ID',
    transferFrom: 'Transfer from',
    transferTo: 'Transfer to',
    fromCreatedAt: 'From created at',
    toCreatedAt: 'To created at',
    fromTimestamp: 'From timestamp',
    toTimestamp: 'To timestamp',
  },
  bankDaySummary: {
    toDate: 'To date',
    fromDate: 'From date',
    bankingDay: 'Banking day',
    totalOperations: 'Total operations number',
    totalAmount: 'Total amount',
    // transfers: 'Transfers',
  },
};
